import React, { memo, ReactNode } from 'react';

import { Box } from '../Box/Box';
import { TruncateText } from '../Text/subcomponents/TruncateText';
import { Text } from '../Text/Text';

type Highlighter = 'ai';

const highlightBgMap: Record<Highlighter, string> = {
  ai: 'status.ai.secondary',
};

interface Props {
  children: ReactNode;
  wrap?: boolean;
  highlighter?: Highlighter;
}

export const Quote = memo(({ children, wrap, highlighter }: Props) => {
  const TextElement = wrap ? Text : TruncateText;
  const content = highlighter ? (
    <Box bg={highlightBgMap[highlighter]}>{children}</Box>
  ) : (
    children
  );

  return (
    <TextElement
      as="blockquote"
      color="text.secondary"
      borderLeft="quote"
      fontStyle="italic"
      pl={2}
      w="100%"
      m={0}
    >
      {content}
    </TextElement>
  );
});
